import { render, staticRenderFns } from "./editvehicle.vue?vue&type=template&id=5ae5f1fc&scoped=true"
import script from "./editvehicle.js?vue&type=script&lang=js&external"
export * from "./editvehicle.js?vue&type=script&lang=js&external"
import style0 from "./editvehicle.vue?vue&type=style&index=0&id=5ae5f1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae5f1fc",
  null
  
)

export default component.exports